import React from 'react'
import { Link } from 'react-router-dom';



function QuizPreview({ id, data, scrollToTop }) {
    let { title, description, type, level } = data;

    const getLevelColor = () => {
        if (level === 'Intro') return 'border-purple-300 hover:border-purple-500 text-purple-700'
        if (level === 'Nível 1') return 'border-green-300 hover:border-green-500 text-green-700'
        if (level === 'Nível 2') return 'border-orange-300 hover:border-orange-500 text-orange-700'
        if (level === 'Nível 3') return 'border-blue-300 hover:border-blue-500 text-blue-700'
        return 'border-gray-300 hover:border-gray-500 text-gray-700'
    }

    return (
        <Link 
            to={`/quiz/${id}`} 
            className="block w-full h-full p-4 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:scale-105 group"
            onClick={scrollToTop}
        >
            <div className='flex flex-col h-full justify-between'>
                <div>
                    <div className="flex items-start justify-between mb-2">
                        <h4 className='text-base font-bold text-gray-900 group-hover:text-purple-600 transition-colors line-clamp-2'>
                            {title}
                        </h4>
                    </div>
                    <p className='text-sm text-gray-600 mb-3 line-clamp-2'>
                        {description}
                    </p>
                </div>
                <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                    <span className={`text-xs font-semibold px-2 py-1 rounded-full border-2 ${getLevelColor()} bg-white`}>
                        {level || 'Quiz'}
                    </span>
                    {type && (
                        <span className='text-xs text-gray-500 italic'>
                            {type}
                        </span>
                    )}
                </div>
            </div>
        </Link>
    )
}

export default QuizPreview